import FlightDetailsAndPackages from '../FlightDetailsAndPackages';
import BaseModal from './BaseModal';

interface Props {
  closeModal: () => void;
  content: any;
  openExtras?: boolean;
  modalOpen: boolean;
}

const PackagesAndExtrasModal: React.FC<Props> = ({
  closeModal,
  content,
  openExtras,
  modalOpen,
}) => {
  return null;
};

export default PackagesAndExtrasModal;
